import { sortBy } from 'lodash';

function getLastSbatLectureId(lectureList = [], referenceDate) {
  const sortedLectureList = sortBy(lectureList, function (o) {
    return o.date_of_topic;
  });
  let lectureId;
  for (const lecture of sortedLectureList) {
    if (new Date(lecture.date_of_topic) > new Date(referenceDate)) {
      break;
    }
    lectureId = lecture.id;
  }
  return lectureId;
}

export default getLastSbatLectureId;
